import { Box, Heading, Text, VStack } from '@gluestack-ui/themed';
import type { ReactNode } from 'react';

export interface EmptyStateProps {
  readonly title: string;
  readonly description?: string;
  /** Optional call to action, e.g. a "Create audit" button. */
  readonly action?: ReactNode;
  readonly testID?: string;
}

/**
 * Shown when a query succeeded but returned nothing, distinct from an error. Plain left-aligned
 * text: the empty area says what is missing and what to do, without an illustration.
 */
export function EmptyState({ title, description, action, testID }: EmptyStateProps): React.JSX.Element {
  return (
    <VStack alignItems="flex-start" py="$2" space="xs" testID={testID}>
      <Heading size="sm">{title}</Heading>
      {description === undefined ? null : (
        <Text size="sm" color="$textLight600" $dark-color="$textDark400">
          {description}
        </Text>
      )}
      {action === undefined ? null : <Box mt="$1">{action}</Box>}
    </VStack>
  );
}
